import React, { useState, useEffect, useRef, useContext } from "react";

import TruPakDashboardController from "../../TruPakDashboard/TruPakDashboardController";
import BarGraph from "../../sharedGraphs/BarGraph";
import { ScreenContext } from "../../../../contexts/ScreenContext";
import { useMediaQuery } from "react-responsive";
import styles from "../TruPakDashboard.module.css";
import stylesMobile from "../MobileViews/TruPakDashboardMobileView.module.css";
import { useTranslation } from "react-i18next";

const GetAlarmsGraph = ({
  onGraphClick,
  user,
  selectedDevices,
  loader,
  startDate,
  stopDate,
}) => {
  const { t } = useTranslation("trupakDashboard");

  const [graphData, setGraphData] = useState([]);
  const [fetchingData, setFetchingData] = useState(false);

  const _controllerRef = useRef(TruPakDashboardController);

  const { smallScreen } = useContext(ScreenContext);
  const smScreen = useMediaQuery(smallScreen);

  useEffect(() => {
    if (selectedDevices.length) {
      async function updateGraph() {
        setGraphData([]);
        setFetchingData(true);
        let emptyCanisterCount = 0;
        let partialFillCount = 0;
        let suspiciousCount = 0;
        let overCountCount = 0;
        let motorFailureCount = 0;
        let countSensorCount = 0;
        let chuteSensorUndetected = 0;

        for (let i = 0; i < selectedDevices.length; i++) {
          const deviceId = selectedDevices[i]._id;
          const site = selectedDevices[i].site;
          await _controllerRef.current
            .getTruPakAlarmHistory(
              user,
              site,
              startDate,
              stopDate,
              false,
              deviceId
            )
            .then((results) => {
              const alarmsData = results.map((result) => {
                return { x: result.error, y: result.count };
              });
              alarmsData.forEach((alarm) => {
                if (alarm.x === "EmptyCanister") {
                  emptyCanisterCount += alarm.y;
                } else if (alarm.x === "PartialFill") {
                  partialFillCount += alarm.y;
                } else if (alarm.x === "Suspicious") {
                  suspiciousCount += alarm.y;
                } else if (alarm.x === "OverCount") {
                  overCountCount += alarm.y;
                } else if (alarm.x === "MotorFailure") {
                  motorFailureCount += alarm.y;
                } else if (alarm.x === "CountSensor") {
                  countSensorCount += alarm.y;
                } else if (alarm.x === "ChuteSensorUndetected") {
                  chuteSensorUndetected += alarm.y;
                }
              });
            });
        }

        let data = [];

        if (emptyCanisterCount > 0) {
          data.push({ x: "EmptyCanister", y: emptyCanisterCount });
        }
        if (partialFillCount > 0) {
          data.push({ x: "PartialFill", y: partialFillCount });
        }
        if (suspiciousCount) {
          data.push({ x: "Suspicious", y: suspiciousCount });
        }
        if (overCountCount) {
          data.push({ x: "OverCount", y: overCountCount });
        }
        if (motorFailureCount) {
          data.push({ x: "MotorFailure", y: motorFailureCount });
        }
        if (countSensorCount) {
          data.push({ x: "CountSensor", y: countSensorCount });
        }
        if (chuteSensorUndetected) {
          data.push({
            x: "CountSensorUndetected",
            y: chuteSensorUndetected,
          });
        }

        setGraphData(data);
        setFetchingData(false);
      }
      if (selectedDevices.length) {
        updateGraph();
      }
    }
  }, [selectedDevices, startDate, stopDate, user]);

  if (selectedDevices.length) {
    return (
      <div
        className={
          smScreen
            ? `${stylesMobile.TruPakDashboard__graphContainerMobile} ${stylesMobile["TruPakDashboard__graphContainerMobile--paddingBottom"]}`
            : `${styles.TruPakDashboard__graphContainerMobile} ${styles["TruPakDashboard__graphContainer--paddingBottom"]}`
        }
        onClick={!fetchingData ? () => onGraphClick(4) : null}
      >
        {fetchingData && loader}
        <BarGraph
          user={user}
          fetchingData={fetchingData}
          stylesName="BarGraph1"
          chartWidth={450}
          chartHeight={288}
          graphData={graphData}
          graphTitle={t("alarmsTitle")}
          palette={["#318ce7"]}
        />
      </div>
    );
  } else {
    return null;
  }
};

export default GetAlarmsGraph;
